import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Download, BookOpen } from "lucide-react";
import { api, resolveFileUrl } from "../api";

export default function BookDetailPage() {
  const { id } = useParams();
  const [book, setBook] = useState(null);
  useEffect(() => { api.get(`/content/books/${id}`).then((r) => setBook(r.data)); }, [id]);
  if (!book) return <div className="max-w-[1600px] mx-auto p-10 font-mono-label">Loading…</div>;
  const pdfUrl = resolveFileUrl(book.file_url);
  return (
    <div className="pb-40">
      <div className="border-b border-neutral-800">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-10 grid md:grid-cols-[260px_1fr] gap-10 items-start">
          <img src={resolveFileUrl(book.cover_image)} alt={book.title} className="w-full aspect-[2/3] object-cover border border-neutral-800" data-testid="book-cover" />
          <div>
            <div className="font-mono-label text-[11px] text-[var(--accent)] mb-3">BOOK / {book.genre} / {book.year}</div>
            <h1 className="font-display text-5xl md:text-6xl uppercase leading-none mb-4" data-testid="book-title">{book.title}</h1>
            <div className="font-headline text-lg uppercase text-neutral-300 mb-6">{book.artist}</div>
            <p className="text-neutral-400 max-w-2xl mb-8">{book.description}</p>
            <div className="flex gap-3 flex-wrap">
              {pdfUrl ? (
                <>
                  <a href={pdfUrl} target="_blank" rel="noreferrer" className="btn-ghost" data-testid="book-download">
                    <Download size={16} /> Download PDF
                  </a>
                </>
              ) : null}
              <Link to="/books" className="btn-ghost">More Books</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
        {pdfUrl ? (
          <>
            <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3 flex items-center gap-2"><BookOpen size={14} /> READ IN-BROWSER</div>
            <div className="border border-neutral-800 h-[80vh]">
              <iframe src={pdfUrl} title={book.title} className="w-full h-full" data-testid="pdf-reader" />
            </div>
          </>
        ) : (
          <div className="border border-dashed border-neutral-800 p-10 font-mono-label text-neutral-500 text-center" data-testid="no-pdf">
            No PDF uploaded for this book yet.
          </div>
        )}
      </div>
    </div>
  );
}
